import striptags from 'striptags';
import { getGalleryActions, getGalleryPlacements } from '../helpers/analytics';
import { replaceNewLineSymbolWithBrForPlainText } from '../helpers/textHelpers';
import { CARD_TYPES } from '../../../constants';
import { prepareTranslations as videoTranslations } from './video';
import {
  getCommonProps,
  getContainerType,
  getTitle,
} from '../helpers/commonHelpers';
import cardMethods from './index';

/**
 * Returns the SEO attributes used to generate JSON LD stucture.
 * @param {Object} stepSlide - the result of prepareCardData
 * @param {Object} imageSlide - optional param with image data
 * @returns {Object} SEO props
 */
const getSEOData = (stepSlide, imageSlide) => {
  const { text = '' } = stepSlide?.bodyProps || {};
  const imageSource = imageSlide || stepSlide;

  return {
    imageURL: imageSource?.landscapeURL || imageSource?.portraitURL,
    text: striptags(replaceNewLineSymbolWithBrForPlainText(text)),
  };
};

const getCarouselSEOData = subslides => {
  const textSlide = subslides.find(
    card => card.containerType === CARD_TYPES.TEXT,
  );
  const imageSlide = subslides.find(
    card => card.containerType === CARD_TYPES.IMAGE,
  );
  const textSource = textSlide || imageSlide || subslides[0];

  return getSEOData(textSource, imageSlide);
};

export const prepareCardData = (cardData, data) => {
  const slides = (cardData?.nodes ?? []).flatMap((slideId, index) => {
    const slide = data.nodes[slideId];
    const headline = {
      counter: index + 1,
      id: `${slideId}_headline`,
      isListicleHeadline: true,
      title: getTitle(slide).title,
    };
    if (slide.subType === CARD_TYPES.CAROUSEL) {
      const subslides = slide.nodes.map(id => {
        const subSlide = data.nodes[id];
        return cardMethods[getContainerType(subSlide)].prepareCardData(
          subSlide,
          data,
        );
      });
      return [
        {
          ...headline,
          seo: {
            ...getCarouselSEOData(subslides),
            title: headline.title,
          },
        },
        ...subslides,
      ];
    }
    const preparedCard = cardMethods[getContainerType(slide)].prepareCardData(
      slide,
      data,
    );
    return [
      {
        ...headline,
        seo: {
          ...getSEOData(preparedCard),
          title: headline.title,
        },
      },
      {
        ...preparedCard,
        // removing title props to avoid duplication with listicle headline
        titleProps: {},
      },
    ];
  });
  return {
    ...getCommonProps(cardData),
    sectionHeadline: getTitle(cardData),
    slides,
  };
};

export const prepareTranslations = translationsStrings => ({
  ...videoTranslations(translationsStrings),
});

export {
  getGalleryUrlIngredients as getUrlIngredients,
  mergeGalleryProperties as mergeProperties,
} from '../helpers/carouselHelper/carouselHelper';

const excludeHeadlines = card => ({
  ...card,
  slides: card.slides.filter(slide => slide.containerType),
});

export const getAnalyticsPlacements = card =>
  getGalleryPlacements(excludeHeadlines(card));

export const getAnalyticsActions = card =>
  getGalleryActions(excludeHeadlines(card));

export { getBuyingToolsIngredients } from './common';
